/**
 * StatusBadge Component
 * Displays verification status for linked sportsbook accounts
 */

import type { ReactElement } from 'react';

interface StatusBadgeProps {
  status: 'verified' | 'unverified' | 'inaccessible' | 'pending';
}

export function StatusBadge({ status }: StatusBadgeProps): ReactElement {
  const styles: Record<string, { bg: string; text: string; label: string }> = {
    verified: { bg: 'bg-theme-success/15', text: 'text-theme-success', label: 'Verified' },
    unverified: { bg: 'bg-theme-warning/15', text: 'text-theme-warning', label: 'Pending' },
    inaccessible: {
      bg: 'bg-theme-danger/15',
      text: 'text-theme-danger',
      label: 'Inaccessible',
    },
    pending: {
      bg: 'bg-theme-surface',
      text: 'text-theme-text-secondary',
      label: 'Pending',
    },
  };

  const style = styles[status] || styles.pending;

  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${style.bg} ${style.text}`}>
      {style.label}
    </span>
  );
}
